import React, { FC, useEffect, useState } from 'react';

import { Categories } from '@ariksa/inventory-core';
import { AppSchemasInventoryResourceCountDeploymentSummary } from '@ariksa/inventory-core/api';
import { Box, Stack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { useAccessBoundary } from 'containers/App/hooks/useAccessBoundary';
import { useSearchParamFunctions } from 'containers/App/hooks/useSearchParamFunctions';
import {
  selectActiveCloudAccount,
  selectActiveEnvironment,
} from 'containers/App/selectors';
import { InstanceInventory } from 'containers/Inventory/CloudInventory/Components/InstanceInventory';
import { InventoryTableTitle } from 'containers/Inventory/CloudInventory/Components/InventoryTableTitle';
import { useInventoryContext } from 'containers/Inventory/CloudInventory/hooks/context';
import { useInventory } from 'containers/Inventory/CloudInventory/hooks/useInventory';

import { selectInventory } from '../../selector';
import { actions } from '../../slice';
import { useCategoryTableColumns } from '../hooks/useCategoryTableColumns';

export const CategoryInventory: FC = () => {
  const dispatch = useDispatch();
  const {
    deploymentSummary,
    currentCategory,
    categories,
    currentCategoryTitle,
    instanceResourceType,
  } = useSelector(selectInventory);
  const { accountId } = useSelector(selectActiveCloudAccount);
  const { environmentId } = useSelector(selectActiveEnvironment);
  const { filterDeploymentSummary } = useInventory();
  const { useInventoryV3 } = useInventoryContext();
  const { updateValueInURL } = useSearchParamFunctions();
  // Only the columns are used: the EC2 summary dialog could no longer be opened, so it was removed.
  const { categoryTableColumns } = useCategoryTableColumns();
  const { withAccessBoundary } = useAccessBoundary();
  const [data, setData] = useState<
    AppSchemasInventoryResourceCountDeploymentSummary[]
  >([]);

  useDeepCompareEffect(() => {
    if (!!accountId || !!environmentId) {
      dispatch(
        actions.getDeploymentSummary({
          q: withAccessBoundary({
            category: currentCategory as Categories,
            useInventoryV3,
          }),
        } as any),
      );
    }
  }, [dispatch, currentCategory, withAccessBoundary, useInventoryV3]);

  useEffect(() => {
    setData(filterDeploymentSummary());
  }, [filterDeploymentSummary]);

  const handleRowClick = row => {
    updateValueInURL('resource_type', row.native_resource);
    //dispatch(actions.setNativeResource(row.native_resource));
    //dispatch(actions.resetSearchItems());
  };

  return !!instanceResourceType ? (
    <InstanceInventory />
  ) : (
    <Stack spacing={4} h="full">
      <InventoryTableTitle
        title={currentCategoryTitle}
        iconType={currentCategory?.split('_')?.[0]}
        value={
          <Box>
            {deploymentSummary?.isLoading || categories?.isLoading
              ? 0
              : data?.length}
            {data?.length > 1 ? ' Entities' : ' Entity'}
          </Box>
        }
      />

      <Table
        columns={categoryTableColumns}
        data={data}
        onRowClick={handleRowClick}
        isLoading={deploymentSummary?.isLoading || categories?.isLoading}
        cursor="pointer"
      />
    </Stack>
  );
};
